export default function LinkedIn({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("LinkedIn")}</legend>
      <input
        onChange={onChange}
        value={searchObject.linkedIn || ""}
        name="linkedIn"
        className="form-control fontsize-legend"
      />
    </div>
  );
}
